import { VideoPlayer } from "./VideoPlayer";
import { ShareBar } from "./ShareBar";
import { MediaModel } from "../models/MediaModel";
import { TopicManager } from "../managers/TopicManager";
import { vp } from "../managers/vp";
import { Component } from "./Component";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class ArticleMediaItem extends Component {
    get showBanner() {
        return this._showBanner;
    }
    constructor(html) {
        super(html || require("../../html/ArticleMediaItem.handlebars")());
        this._paramsData = null;
        this._showBanner = false;
        this.initVideo = (videoModel) => {
            this._videoModel = videoModel;
            const bodyHtml = this.getHtml('body');
            if (this._isHandlebarTemplate) {
                this.html.setAttribute('data-type', videoModel.type);
                const body = videoModel.bodyHtml;
                if (!body && this._paramsData && this._paramsData.isPopup && this._bannerWrapperHtml) {
                    this.addPopupBanner();
                }
                this.getHtml('title').textContent = videoModel.getArticleTitle();
                bodyHtml.innerHTML = body;
                let tagsHtmlStr = '';
                videoModel.tags.forEach((tag, index) => {
                    if (index !== 0) {
                        tagsHtmlStr += ', ';
                    }
                    tagsHtmlStr += '<a href="' + tag.url + '" >' + tag.title + '</a>';
                });
                if (tagsHtmlStr) {
                    this.getHtml('tags').innerHTML = 'Tags: ' + tagsHtmlStr;
                }
                const info = this.getHtml('info');
                if ((!videoModel.params || !videoModel.params.url) && (!videoModel.metaTitle || !videoModel.metaUrl)) {
                    this.getHtml('icon', info).style.display = 'none';
                }
                if (videoModel.params && videoModel.params.url) {
                    this.getHtml('url', info).setAttribute('href', videoModel.params.url);
                }
                else {
                    this.getHtml('url', info).style.display = 'none';
                }
                if (videoModel.metaTitle && videoModel.metaUrl) {
                    const sourceA = this.getHtml('source-a', info);
                    sourceA.href = videoModel.metaUrl;
                    sourceA.textContent = videoModel.metaTitle;
                }
                else {
                    this.getHtml('source', info).style.display = 'none';
                }
                this.getHtml('date', info).textContent = videoModel.chronologicalDateString;
            }
            if (!this._videoModel.bodyHtml) {
                bodyHtml.style.display = 'none';
            }
            this._videoPlayer = new VideoPlayer();
            this._shareBar = new ShareBar();
            const videoPlayerContainerHtml = this.getHtml('video_player_container');
            const shareContainerHtml = this.getHtml('share_container');
            const parentDiv = document.createElement("div");
            parentDiv.appendChild(this._videoPlayer.html);
            parentDiv.setAttribute("class", "ArticleMediaItem-video-parent");
            const videoFcLogo = document.createElement("img");
            videoFcLogo.setAttribute("class", "ArticleMediaItem-video-logo");
            videoFcLogo.src = vp.config.createImageUrl('logo-grey-barless.webp');
            videoPlayerContainerHtml.appendChild(parentDiv);
            videoPlayerContainerHtml.appendChild(videoFcLogo);
            shareContainerHtml.appendChild(this._shareBar.html);
            this._videoPlayer.init(videoModel);
            this._shareBar.init(videoModel);
        };
        this._isHandlebarTemplate = !html;
        this._bannerWrapperHtml = this.getHtml('banner_wrapper', null, true);
    }
    init(parameters = null) {
        if (this._initPromise) {
            return this._initPromise;
        }
        this._paramsData = parameters ? parameters.data : null;
        return this._initPromise = new Promise((resolve, reject) => {
            if (!this._paramsData) {
                this._paramsData = { topicID: this.html.getAttribute('data-id') || '', videoModel: null };
                if (!this._paramsData.topicID) {
                    logger.error('article doesnt have an data-id attr');
                }
                this._paramsData.videoModel = new MediaModel(TopicManager.getDataFromTemplate(this._paramsData.topicID));
            }
            if (this._paramsData.videoModel && !this._paramsData.videoModel.notComplete()) {
                this.initVideo(this._paramsData.videoModel);
                resolve();
            }
            else {
                if (this._paramsData.videoModel) {
                    logger.warn('Looks like there was data available but you forgot to add "' + this._paramsData.videoModel.notComplete() + '". -> ' + (this._paramsData.videoModel.id));
                }
                MediaModel.fetch(this._paramsData.topicID).then(this.initVideo).catch((e) => {
                    logger.error(e.stack);
                    reject();
                }).then(() => {
                    resolve();
                });
            }
        }).catch((e) => {
            logger.error(e);
        });
    }
    gaTrackAsPage() {
        vp.statisticsManager.trackPage(this._videoModel.url);
    }
    get videoModel() {
        return this._videoModel;
    }
    addPopupBanner() {
        this._showBanner = true;
        this.html.setAttribute('banner', 'true');
        this._bannerWrapperHtml.appendChild(DomUtils.createElement('<div id="slot_popup" class="BannerSpace"></div>'));
    }
    destroy() {
        if (this._videoPlayer) {
            this._videoPlayer.destroy();
        }
    }
}
